<ng-select
    *ngIf="customers$ | async as customers"
    placeholder="Search by email address"
    [items]="customers"
    appendTo="body"
    [addTag]="false"
    [multiple]="false"
    bindValue="id"
    bindLabel="emailAddress"
    [compareWith]="compareWith"
    [clearable]="true"
    (search)="searchInput$.next($event)"
    [typeahead]="searchInput$"
    [searchable]="true"
    [trackByFn]="trackById"
    [(ngModel)]="selectedCustomer"
    (change)="selectCustomer($event)"
>
    <ng-template ng-label-tmp let-item="item">
        <span>{{ item?.emailAddress }}</span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <span>{{ item?.emailAddress }}</span>
    </ng-template>
</ng-select>
